import { render, staticRenderFns } from "./select_bedr_codes.vue?vue&type=template&id=af6bcdb8&scoped=true"
import script from "./select_bedr_codes.vue?vue&type=script&lang=js"
export * from "./select_bedr_codes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6bcdb8",
  null
  
)

export default component.exports